export default "__VITE_ASSET__BKI_Q4w1__"